// GENERATED FILE - DO NOT MODIFY
export enum InventoryTransferQtyValidation {
    Warning = "1",
    Block = "0",
}

export let nameof = "InventoryTransferQtyValidation";
